import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "@/lib/api";
import { REKLAME_SUBS } from "@/lib/categories";
import { REKLAME_COUNTRIES, REKLAME_CITIES } from "@/lib/places";
import { ListingCard } from "@/components/ListingCard";

export default function ReklamePage() {
  const [sub, setSub] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const cities = REKLAME_CITIES[country] || [];

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ category: "reklame" });
    if (sub) params.set("subcategory", sub);
    if (country) params.set("country", country);
    if (city) params.set("city", city);
    api.get(`/listings?${params.toString()}`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [sub, country, city]);

  return (
    <div className="gs-fade">
      {/* HERO */}
      <div className="bg-gradient-to-br from-fuchsia-500 to-purple-600 text-white px-4 pt-5 pb-6 rounded-b-3xl">
        <h1 className="text-3xl font-extrabold flex items-center gap-2"><Megaphone className="w-8 h-8" />Reklamë</h1>
        <p className="text-white/85 text-sm mt-1">Reklama nga 🇽🇰 🇦🇱 🇲🇰 🇲🇪</p>
      </div>

      {/* FILTRAT */}
      <div className="px-4 mt-4 space-y-3">
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
          <button data-testid="reklame-sub-all" onClick={() => setSub("")} className={`shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full border ${!sub ? "bg-fuchsia-600 text-white border-fuchsia-600" : "bg-white text-slate-600 border-slate-200"}`}>Të gjitha</button>
          {REKLAME_SUBS.map((s) => (
            <button key={s} data-testid={`reklame-sub-${s}`} onClick={() => setSub(sub === s ? "" : s)} className={`shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full border ${sub === s ? "bg-fuchsia-600 text-white border-fuchsia-600" : "bg-white text-slate-600 border-slate-200"}`}>{s}</button>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-2">
          <select data-testid="reklame-filter-country" value={country} onChange={(e) => { setCountry(e.target.value); setCity(""); }} className="w-full bg-white border border-slate-200 rounded-xl h-11 px-2 text-sm outline-none">
            <option value="">Të gjitha shtetet</option>
            {REKLAME_COUNTRIES.map((c) => <option key={c.name} value={c.name}>{c.flag} {c.name}</option>)}
          </select>
          <select data-testid="reklame-filter-city" value={city} onChange={(e) => setCity(e.target.value)} disabled={!country} className="w-full bg-white border border-slate-200 rounded-xl h-11 px-2 text-sm outline-none disabled:bg-slate-50 disabled:text-slate-400">
            <option value="">{country ? "Të gjitha qytetet" : "Zgjidh shtetin"}</option>
            {cities.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      </div>

      {/* LISTA */}
      <div className="px-4 mt-4 pb-8">
        {loading ? (
          <p className="text-center text-slate-400 py-10 text-sm">Duke ngarkuar...</p>
        ) : items.length ? (
          <div className="grid grid-cols-2 gap-3">
            {items.map((l) => <ListingCard key={l.id} listing={l} />)}
          </div>
        ) : (
          <div className="text-center py-16 text-slate-400">
            <Megaphone className="w-12 h-12 mx-auto mb-2 opacity-40" />
            <p className="text-sm">Ende pa reklama këtu.</p>
          </div>
        )}
      </div>
    </div>
  );
}
